import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {CashUsageResultVo} from '../../common/shared/api/nicolas/vo/SalesTicketVo.interface';

/**
 * 캐시 사용 내역 조회
 *
 * Origin: pageNicolasApi.getCashUsageHistory
 * API: POST /gateway/api/v1/store/cash_history/usage
 */
export async function postStoreCashHistoryUsage(
  params?: {
    page?: number;
  },
  options?: FetcherOptions
): Promise<CashUsageResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/cash_history/usage',
    {
      method: 'POST',
      data: {
        page: params?.page,
      },
    },
    options
  );
  return response.data;
}
